import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export interface GenericTableItemProps {
  item: string;
  formatFn?: (value: any) => ReactNode;
}

export const GenericListItem: FC<GenericTableItemProps> = (props) => {
  const { item, formatFn } = props;
  return (
    <Wrapper>
      {formatFn ? <>{formatFn(item)}</> : <>{item}</>}
    </Wrapper>
  );
};
